/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import { AutoMailActionTypes } from '../../action/auto_action/AutoMailActions'
import { AutoTaskActionTypes } from '../../action/auto_action/AutoTaskActions'
import SiteReferrerOptionState from './state/SiteReferrerOptionState'
import SiteReferrerEvent from '../../event/SiteReferrerEvent'

class SiteReferrerOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      // TODO ひとつにまとめる
      case AutoMailActionTypes.fetchSiteReferrers:
      case AutoTaskActionTypes.fetchSiteReferrers:
      case SiteReferrerEvent.fetchSiteReferrers:
        const site_referrers = payload.site_referrers.map(site_referrer => {
          return new SiteReferrerOptionState().mergeModel(site_referrer)
        })
        return List(site_referrers)

      default:
        return state
    }
  }
}

export default new SiteReferrerOptionsStore()
